import { Component, Inject, LOCALE_ID, OnDestroy, OnInit } from "@angular/core";
import { MsalService } from "@azure/msal-angular";
import { Store } from "@ngrx/store";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { Userprofile } from "src/app/_models/Userprofile";
import { GetOwnUserProfile } from "src/app/_store/user-profile/user-profile.actions";
import { selectOwnUserProfile } from "src/app/_store/user-profile/user-profile.selectors";
import { Roles } from "src/app/constants/Roles";
import { AppConstants } from "src/app/constants/constants";

@Component({
selector: "app-privacy-policy",
  templateUrl: "./privacy-policy.component.html",
  styleUrls: ["./privacy-policy.component.scss"]
})
export class PrivacyPolicyComponent implements OnInit, OnDestroy {
  siteLanguageCode: string = this.localeId;
  isLoggedIn: boolean = false;
  pdfSrcDefault: string = ".././assets/pdf/Privacy Notice.pdf";
  pdfSrcWelsh: string = ".././assets/pdf/Hysbysiad Preifatrwydd.pdf";
  pdfSrc: string;
  privacyPolicyDestroy$: Subject<void> = new Subject<void>();
  isAdmin: boolean = false;
  adminRoles: Roles[] = [Roles.SystemAdministrator, Roles.OrganisationalAdministrator, Roles.ContentAdministrator, Roles.GlobalAdministrator, Roles.Tutor];

  constructor(
    @Inject(LOCALE_ID) protected localeId: string,
    private authService: MsalService, 
    private store: Store) { }

  ngOnInit(): void {
    this.isLoggedIn = this.authService.instance.getAllAccounts().length > 0;

    if(this.isLoggedIn)
    {
      this.store.dispatch(GetOwnUserProfile());
    }

    this.store.select(selectOwnUserProfile)
    .pipe(takeUntil(this.privacyPolicyDestroy$))
    .subscribe((userProfileResponse: Userprofile) => {
      if (userProfileResponse !== null) {
        this.isAdmin = this.adminRoles.includes(userProfileResponse.roleId);
      }
    });

    if(this.siteLanguageCode) {
      this.pdfSrc = this.siteLanguageCode == AppConstants.WELSH_LANG_CODE ? this.pdfSrcWelsh : this.pdfSrcDefault;
    }
  }

  ngOnDestroy(): void {
    this.privacyPolicyDestroy$.next();
    this.privacyPolicyDestroy$.unsubscribe();
  }

  downloadPdf(): void {
    if(this.pdfSrc) {
      let link = document.createElement("a");
      link.download = this.pdfSrc;
      link.href = this.pdfSrc;
      link.click();
    }
  }
}
